<template>
  <el-form-item :label="form.cname+':'"
    :key="form.key"
    :prop="prop"
    :rules="rule">
    <el-upload style="display: inline-block;vertical-align: top;margin: 0 8px 8px 0;"
      action=""
      ref="upload"
      accept="image/*"
      :class="{ 'plus-hidden': form.fieldValue.length >= 3 || status !== 'edit' }"
      list-type="picture-card"
      :show-file-list="false"
      :auto-upload="false"
      :on-change="handleChange">
      <i class="el-icon-plus"></i>
    </el-upload>
    <ul class="el-upload-list el-upload-list--picture-card">
      <li tabindex="0"
        v-for="(item, index) in form.fieldValue"
        :key="index"
        class="el-upload-list__item is-success">
        <img :src="item.url"
          class="el-upload-list__item-thumbnail">
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview">
            <i class="el-icon-zoom-in"
              @click="handlePictureCardPreview(item)"></i>
          </span>
          <span class="el-upload-list__item-delete"
            v-if="status === 'edit'">
            <i class="el-icon-delete"
              @click="handleRemove(index)"></i>
          </span>
        </span>
      </li>
    </ul>
    <img v-if="(!form.fieldValue || !form.fieldValue.length) && status !== 'edit'"
      :src="nopic">
    <div class="el-upload__tip"
      v-if="status === 'edit'"
      style="margin-top:0">只能上传jpg/png文件，最多3张，且每张不超过2M</div>
    <el-dialog :visible.sync="previewVisible"
      width="600px"
      append-to-body>
      <img width="100%"
        :src="previewUrl">
    </el-dialog>
  </el-form-item>
</template>

<script>
export default {
  name: 'form-image',
  components: {},
  props: {
    item: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    prop: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'edit'
    }
  },
  data () {
    return {
      nopic: require('@/assets/images/nopic.png'),
      previewVisible: false,
      previewUrl: ''
    }
  },
  watch: {},
  computed: {
    form: {
      get () {
        return this.item
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    rule () {
      return [
        {
          required: this.form.mandatory,
          message: this.form.cname + '不能为空',
          trigger: 'change'
        }
      ]
    }
  },
  methods: {
    handleChange (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return
      }
      this.uploadFile(file.raw)
    },
    uploadFile (file) {
      let form = new FormData()
      form.append('file', file)
      this.$store.dispatch('common/uploadfile', {
        payload: form,
        success: (res) => {
          this.form.fieldValue.push({
            url: res.data.viewUrl + res.data.filepath,
            filepath: res.data.filepath
          })
          this.$refs.upload.clearFiles()
        },
        fail: () => {
          this.$refs.upload.clearFiles()
        }
      })
    },
    handleRemove (index) {
      this.form.fieldValue.splice(index, 1)
    },
    handlePictureCardPreview (item) {
      this.previewUrl = item.url
      this.previewVisible = true
    }
  }
}
</script>
<style lang="stylus">
.plus-hidden {
  .el-upload.el-upload--picture-card {
    display: none;
  }
}
</style>
